import extract from 'flarum/common/utils/extract';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
export default function recipientLabel(recipient, attrs = {}) {
  attrs.style ??= {};
  attrs.className = 'RecipientLabel ' + (attrs.className || '');
  const link = extract(attrs, 'link');
  return m(link ? 'a' : 'span', attrs, m("span", {
    className: "RecipientLabel-text"
  }, m(Avatar, {
    user: recipient
  }), username(recipient)));
}
flarum.reg.add('flatrate-private-messages-bridge', 'forum/components/recipientLabel', recipientLabel);